// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `select {
  width: 100%;
  height: 35px;
  margin: 0 0 15px 0;
  outline: none;
  padding: 0 10px 0 10px;
  border: solid 1px #e2e2e2;
  border-radius: 3px;
  background-image: url("/assets/img/arrow-down.png");
  background-size: 30px;
  background-repeat: no-repeat;
  background-position-x: calc(100% - 10px);
  background-position-y: 6px;
}

select::-ms-expand {
  display: none;
}

select {
  appearance: none;
}

.logo-banco {
  background-size: 75px 75px;
  width: 75px;
  height: 75px;
  margin: 0 auto;
  transition: 0.5s;
}
.logo-banco.bradesco {
  background-image: url('logo-bradesco.png');
}
.logo-banco.santander {
  background-image: url('logo-santander.png');
}
.logo-banco.banco-do-brasil {
  background-image: url('logo-banco-do-brasil.png');
}
.logo-banco.grayscale {
  filter: grayscale(100%);
  opacity: 0.3;
  transition: 0.5s;
}

.cedente {
  background-color: rgba(0, 0, 0, 0);
  transition: 1s;
}
.cedente.padrao {
  background-color: #FFF;
  transition: 1s;
}

.menu-button {
  width: 7px;
  height: 19px;
  display: block;
  background-image: url(/assets/icones/menu-edit.svg);
  background-repeat: no-repeat;
  padding: 10px;
  background-position: center;
  cursor: pointer;
  float: right;
  position: relative;
  top: -40px;
}
.menu-button .menu {
  position: relative;
  left: -119px;
  top: -10px;
  background-color: #fff;
  width: 100px;
  height: 60px;
  border: none;
  border-radius: 3px;
  box-shadow: 0px 0px 12px -2px rgba(0, 0, 0, 0.21);
}
.menu-button .menu .menu-option {
  line-height: 30px;
  text-align: center;
  transition: 0.5s;
}
.menu-button .menu .menu-option:hover {
  background-color: rgba(226, 226, 226, 0.5);
  transition: 0.5s;
}

.radio-padrao {
  margin-bottom: 20px;
  margin-left: 5px;
}
.radio-padrao span {
  font-style: italic;
  color: #cccccc;
}
.radio-padrao .error-message {
  color: #e57373;
  float: right;
  text-align: right;
  position: relative;
  right: 50px;
}

.animate-card-down-cedente {
  animation-duration: 1s;
  animation-name: animate-height-down;
  animation-fill-mode: forwards;
  transition: height 0.3s;
}

@keyframes animate-height-down-cedente {
  from {
    height: 220px;
  }
  to {
    height: 390px;
  }
}
.animate-card-up-cedente {
  animation-duration: 1s;
  animation-name: animate-height-up;
  animation-fill-mode: forwards;
  transition: height 0.3s;
}

@keyframes animate-height-up-cedente {
  from {
    height: 390px;
  }
  to {
    height: 220px;
  }
}
.remove {
  animation-duration: 1s;
  animation-name: animate-remove;
  animation-fill-mode: forwards;
  transition: height 0.2s;
}

@keyframes animate-remove {
  from {
    height: 220px;
  }
  to {
    padding-top: 0px;
    padding-bottom: 0px;
    margin-top: 0px;
    margin-bottom: 0px;
    height: 0px;
  }
  100% {
    opacity: 0;
  }
}
.card {
  height: 220px;
}

@media (max-width: 767px) {
  .card {
    height: auto;
  }
  form > div:last-child {
    margin-top: 30px;
    text-align: center;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/modules/dashboard/components/minha-conta/configuracoes/card-cedente/card-cedente.component.scss","webpack://./src/sass/_variables.scss"],"names":[],"mappings":"AAGA;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mDAAA;EACA,qBAAA;EACA,4BAAA;EACA,wCAAA;EACA,0BAAA;AAFJ;;AAKA;EACI,aAAA;AAFJ;;AAKA;EAEI,gBAAA;AAFJ;;AAKA;EACI,0BAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,gBAAA;AAFJ;AAGI;EACI,0CAAA;AADR;AAGI;EACI,2CAAA;AADR;AAGI;EACE,iDAAA;AADN;AAGI;EAEI,uBAAA;EACA,YAAA;EACA,gBAAA;AADR;;AAKA;EACI,kCAAA;EACA,cAAA;AAFJ;AAGI;EACI,sBAAA;EACA,cAAA;AADR;;AAKA;EACI,UAAA;EACA,YAAA;EACA,cAAA;EACA,mDAAA;EACA,4BAAA;EACA,aAAA;EACA,2BAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;AAFJ;AAII;EACI,kBAAA;EACA,YAAA;EACA,UAAA;EACA,sBCnDA;EDoDA,YAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,iDAAA;AAFR;AAIQ;EACI,iBAAA;EACA,kBAAA;EACA,gBAAA;AAFZ;AAKQ;EACI,0CAAA;EACA,gBAAA;AAHZ;;AAQA;EACI,mBAAA;EACA,gBAAA;AALJ;AAOI;EACI,kBAAA;EACA,cCnFI;AD8EZ;AAQI;EACI,cCxEC;EDyED,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,WAAA;AANR;;AAUA;EACI,sBAAA;EACA,mCAAA;EACA,6BAAA;EACA,uBAAA;AAPJ;;AAUA;EACI;IACI,aAAA;EAPN;EASE;IACI,aAAA;EAPN;AACF;AAUA;EACI,sBAAA;EACA,iCAAA;EACA,6BAAA;EACA,uBAAA;AARJ;;AAWA;EACI;IACI,aAAA;EARN;EAUE;IACI,aAAA;EARN;AACF;AAWA;EACI,sBAAA;EACA,8BAAA;EACA,6BAAA;EACA,uBAAA;AATJ;;AAYA;EACI;IACI,aAAA;EATN;EAWE;IACI,gBAAA;IACA,mBAAA;IACA,eAAA;IACA,kBAAA;IACA,WAAA;EATN;EAWE;IACI,UAAA;EATN;AACF;AAYA;EACI,aAAA;AAVJ;;AAaA;EACI;IACI,YAAA;EAVN;EAaE;IACI,gBAAA;IACA,kBAAA;EAXN;AACF","sourcesContent":["\n@import '../../../../../../../sass/variables';\n\nselect {\n    width: 100%;\n    height: 35px;\n    margin: 0 0 15px 0;\n    outline: none;\n    padding: 0 10px 0 10px;\n    border: solid 1px $cinza-300;\n    border-radius: 3px;\n    background-image: url(\"/assets/img/arrow-down.png\");\n    background-size: 30px;\n    background-repeat: no-repeat;\n    background-position-x: calc(100% - 10px);\n    background-position-y: 6px;\n}\n\nselect::-ms-expand {\n    display: none;\n}\n\nselect{\n    -webkit-appearance: none;\n    appearance: none;\n}\n\n.logo-banco {\n    background-size: 75px 75px;\n    width: 75px;\n    height: 75px;\n    margin: 0 auto;\n    transition: 0.5s;\n    &.bradesco {\n        background-image: url('./../../../../../../../assets/img/logo-bradesco.png');\n    }\n    &.santander {\n        background-image: url('./../../../../../../../assets/img/logo-santander.png');\n    }\n    &.banco-do-brasil {\n      background-image: url('./../../../../../../../assets/img/logo-banco-do-brasil.png');\n    }\n    &.grayscale {\n        -webkit-filter: grayscale(100%);\n        filter: grayscale(100%);\n        opacity: 0.3;\n        transition: 0.5s;\n    }\n}\n\n.cedente {\n    background-color: rgba(0, 0, 0, 0);\n    transition: 1s;\n    &.padrao {\n        background-color: #FFF;\n        transition: 1s;\n    }\n}\n\n.menu-button {\n    width: 7px;\n    height: 19px;\n    display: block;\n    background-image: url(/assets/icones/menu-edit.svg);\n    background-repeat: no-repeat;\n    padding: 10px;\n    background-position: center;\n    cursor: pointer;\n    float: right;\n    position: relative;\n    top: -40px;\n\n    .menu {\n        position: relative;\n        left: -119px;\n        top: -10px;\n        background-color: $white;\n        width: 100px;\n        height: 60px;\n        border: none;\n        border-radius: 3px;\n        box-shadow: 0px 0px 12px -2px rgba(0, 0, 0, 0.21);\n\n        .menu-option {\n            line-height: 30px;\n            text-align: center;\n            transition: 0.5s;\n        }\n\n        .menu-option:hover {\n            background-color: rgba($cinza-300, 0.5);\n            transition: 0.5s;\n        }\n    }\n}\n\n.radio-padrao {\n    margin-bottom: 20px;\n    margin-left: 5px;\n\n    span {\n        font-style: italic;\n        color: $cinza-400;\n    }\n\n    .error-message {\n        color: $danger;\n        float: right;\n        text-align: right;\n        position: relative;\n        right: 50px;\n    }\n}\n\n.animate-card-down-cedente {\n    animation-duration: 1s;\n    animation-name: animate-height-down;\n    animation-fill-mode: forwards;\n    transition: height 0.3s;\n}\n\n@keyframes animate-height-down-cedente {\n    from {\n        height: 220px;\n    }\n    to {\n        height: 390px;\n    }\n}\n\n.animate-card-up-cedente {\n    animation-duration: 1s;\n    animation-name: animate-height-up;\n    animation-fill-mode: forwards;\n    transition: height 0.3s;\n}\n\n@keyframes animate-height-up-cedente {\n    from {\n        height: 390px;\n    }\n    to {\n        height: 220px;\n    }\n}\n\n.remove {\n    animation-duration: 1s;\n    animation-name: animate-remove;\n    animation-fill-mode: forwards;\n    transition: height 0.2s;\n}\n\n@keyframes animate-remove {\n    from {\n        height: 220px;\n    }\n    to {\n        padding-top: 0px;\n        padding-bottom: 0px;\n        margin-top: 0px;\n        margin-bottom: 0px;\n        height: 0px;\n    }\n    100% {\n        opacity: 0;\n    }\n}\n\n.card {\n    height: 220px;\n}\n\n@media (max-width: 767px) {\n    .card {\n        height: auto;\n    }\n\n    form > div:last-child {\n        margin-top: 30px;\n        text-align: center;\n    }\n}\n","// -------\n// Paleta de Cores\n// -------\n\n// Cores da Identidade - Listadas com base no gradiente principal\n\n$azul-200: #00f6ff;\n$azul-300: #00caff;\n$azul-400: #22b7ff;\n$azul-500: #4379ff;\n$violeta: #6a5cff;\n$roxo-500: #8e42ff;\n$roxo-400: #a42cff;\n$roxo-300: #a900ff;\n\n// Tons neutros \n\n$cinza-600: #777777;     //textos \"on\" - textos principais\n$cinza-500: #999999;     //textos \"off\" - textos auxiliares\n$cinza-400: #cccccc;      \n$cinza-300: #e2e2e2;     //bordas - menos vivo que o texto off\n$cinza-200: #e6e6e6;     //Para bullet points, e etc.\n$cinza-100: #ececec;     //tom mais claro de cinza após o background\n\n$background-common: #f7f7f7;\n$white: #fff;\n\n// Cores padrões\n\n$primary: $violeta;\n$secondary: $cinza-200;\n$success: $azul-500;\n$info: $azul-400;\n$warning: #edaf80;\n$danger: #e57373;\n$inverse: $cinza-500;\n\n\n//fontes - variáveis\n\n$fonte-pague-la: \"Pague.la\", \"Open Sans\", sans-serif;\n$fonte-open-sans: \"Open Sans\", sans-serif;\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
